import React, {useEffect, useState} from "react"
import {Button, Stack, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

interface ReturnToStartScreenProps {
    time: number;
    showCloseButton?: boolean;
}

const ReturnToStartScreenTimer = ({time, showCloseButton = true}: ReturnToStartScreenProps) => {
    const { t } = useTranslation()
    const [count, setCount] = useState(time);

    useEffect(() => {
        if (count === 0) {
            window.location.reload();
            return;
        }
        const timer = setTimeout(() => setCount(count - 1), 1000);
        return () => clearTimeout(timer);
    }, [count]);

    return (<Stack direction="column" alignItems={"center"} spacing={2}>
        <Stack direction="row" alignItems={"center"} spacing={4}>
            <Typography variant="body1">
                {`${t('selfService.screenReturns')} ${count} ${t('selfService.inSeconds')}`}
            </Typography>
        </Stack>
        {showCloseButton &&
            <Button variant="contained" color="secondary" onClick={() => window.location.reload()}>
                {t('selfService.close')}
            </Button>
        }
    </Stack>)
}

export default ReturnToStartScreenTimer
